module.exports = __webpack_public_path__ + "img/img_certification_mark_03.426fb17.png";